import { render, staticRenderFns } from "./EndCardLayersSettings.vue?vue&type=template&id=72e0e56a&scoped=true&"
import script from "./EndCardLayersSettings.vue?vue&type=script&lang=ts&"
export * from "./EndCardLayersSettings.vue?vue&type=script&lang=ts&"
import style0 from "./EndCardLayersSettings.vue?vue&type=style&index=0&id=72e0e56a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e0e56a",
  null
  
)

export default component.exports